var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAddCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 36,
    viewBox: "0 0 55 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 36,
    rx: 3,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6848 10.7027C28.6848 10.2057 28.2818 9.80273 27.7848 9.80273C27.2877 9.80273 26.8848 10.2057 26.8848 10.7027V17.3027H20.2848C19.7877 17.3027 19.3848 17.7057 19.3848 18.2027C19.3848 18.6998 19.7877 19.1027 20.2848 19.1027H26.8848V25.7027C26.8848 26.1998 27.2877 26.6027 27.7848 26.6027C28.2818 26.6027 28.6848 26.1998 28.6848 25.7027V19.1027H35.2848C35.7818 19.1027 36.1848 18.6998 36.1848 18.2027C36.1848 17.7057 35.7818 17.3027 35.2848 17.3027H28.6848V10.7027Z",
    fill: "#333230"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddCard);
export default __webpack_public_path__ + "static/media/icon_add_card.60f97dfeff4a210e5bc10ca9d673ef69.svg";
export { ForwardRef as ReactComponent };